module.exports = __webpack_public_path__ + "static/media/react.91c5fe37.png";